module.exports = __webpack_public_path__ + "static/download_app_QR-f8eb35bd7357b90a904dd379a6071433.jpg";